import useCategoryStore from '@/store/category.store';
import { chunkProductsWithBanners } from '@/utils/category';
import { findObjectById, modifyMenuTreeData } from '@/utils/global';
import React from 'react';
import { ProductCard } from '../ui/cards';
// import { CategoryBanner } from '../banners';

function ProductList({ categoryId, products }) {
  const { categoryTreeData } = useCategoryStore((state) => state);
  const categories = modifyMenuTreeData(categoryTreeData?.children_data);
  const selectedData =
    Array.isArray(categories) && categories?.length
      ? findObjectById(categories, categoryId)
      : null;
  const { chunks: productChunks } = chunkProductsWithBanners(
    products,
    selectedData?.category_banners || [],
    8
  );

  return (
    <div className='grid grid-cols-2 gap-[11px] sm:gap-[15px] md:grid-cols-3 lg:grid-cols-4 lg:gap-5'>
      {productChunks.map(({ products: chunk }, chunkIndex) => {
        const chunkOffset = productChunks
          .slice(0, chunkIndex)
          .reduce((total, item) => total + (item?.products?.length || 0), 0);

        return (
          <React.Fragment key={chunkIndex}>
            {/* Render Products by chunk */}

            {chunk?.map((product, productIndex) => {
              const globalIndex = chunkOffset + productIndex;

              return (
                <ProductCard
                  key={product.entity_id}
                  product={product}
                  priority={globalIndex < 12}
                  page='category-page'
                  index={globalIndex}
                />
              );
            })}

            {/* Render banners */}
            {/* {i < bannerCount && products?.length > 8 && (
            <div className='col-span-full *:my-0 *:w-full'>
              <CategoryBanner data={banners} />
            </div>
          )} */}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default ProductList;
